import React from "react";
import cx from "classnames";
import { css } from "@linaria/core";
import { spacings } from "../Theme";

export function MarkdownSection({ children, className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cx(markdownSection, className)} {...props}>
      {children}
    </div>
  );
}

const markdownSection = css`
  padding: ${spacings.xxs} ${spacings.s} ${spacings.xs} ${spacings.s};
`;
